import { affiliateApi } from "@/lib/axios";
import type { TikTokAdRequestChecklistItem, TikTokAdRequestStatus, TikTokAdRequestVideo } from "./tiktokShop.service";

/** A brand's "request for ads" as the creator sees it. */
export interface AffiliateAdRequest {
  id: string;
  status: TikTokAdRequestStatus;
  brand: { id: string; name: string; username: string | null; logoUrl: string | null };
  program: { id: string; title: string };
  video: TikTokAdRequestVideo;
  flatFee: number | null;
  commissionRate: number;
  checklist: TikTokAdRequestChecklistItem[];
  notes: string | null;
  expiresAt: string;
  /** The signed-in affiliate is enrolled with the brand, so accept works. */
  enrolled: boolean;
}

export const AD_REQUEST_TOKEN_KEY = "pendingAdRequestToken";

export async function listMyAdRequests(): Promise<AffiliateAdRequest[]> {
  const { data } = await affiliateApi.get<AffiliateAdRequest[]>("/affiliate/ad-requests/me");
  return data;
}

export async function getMyAdRequest(id: string): Promise<AffiliateAdRequest> {
  const { data } = await affiliateApi.get<AffiliateAdRequest>(`/affiliate/ad-requests/me/${id}`);
  return data;
}

export async function getAdRequestInvite(token: string): Promise<AffiliateAdRequest> {
  const { data } = await affiliateApi.get<AffiliateAdRequest>(`/affiliate/ad-requests/invite/${encodeURIComponent(token)}`);
  return data;
}

/**
 * Binds the request to the signed-in affiliate. 409 AD_REQUEST_JOIN_REQUIRED
 * means they must join the brand first (the token pre-approves that join).
 */
export async function acceptAdRequest(token: string): Promise<{ id: string; programId: string; status: TikTokAdRequestStatus }> {
  const { data } = await affiliateApi.post(`/affiliate/ad-requests/invite/${encodeURIComponent(token)}/accept`);
  return data;
}

/** Where a creator goes to answer an accepted request. */
export const adRequestSubmitPath = (programId: string, requestId: string) =>
  `/affiliate/content-programs/${programId}/submit?adRequest=${requestId}`;
